import { render, staticRenderFns } from "./registry-filter-option-display.vue?vue&type=template&id=523fadef&scoped=true&"
import script from "./registry-filter-option-display.ts?vue&type=script&lang=ts&"
export * from "./registry-filter-option-display.ts?vue&type=script&lang=ts&"
import style0 from "./registry-filter-option-display.scss?vue&type=style&index=0&id=523fadef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523fadef",
  null
  
)

export default component.exports